import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import {useResults} from '../hooks';

const Result = ({ appId, showResults, onRenderComplete }) => {
  const { state } = useStateMachine();
  const message = useResults(state[appId]);
  let answerIndex = 0;
  const resultRef = useRef(null);

  const [answerTexts, setAnswerTexts] = useState();

  useEffect(() => {
    if (message === undefined) return null

    // TODO: For debug info
    if (state[appId]?.data.debug && message.length > 0) {
      console.info('Result message => ', message);
    }

    resultRef.current.scrollIntoView();
  }, [message]);

  useEffect(() => {
    resultRef.current.scrollIntoView();
  }, []);

  useEffect(() => {
    if(onRenderComplete) {
      onRenderComplete();
    }
  }, [onRenderComplete]);

  useEffect(() => {
    setAnswerTexts(Object.values(state[appId].currentValues));
  }, [state[appId].currentValues])

  return (
    <>
      <div
        id="result"
        className="pt-6 cke"
        ref={resultRef}
      >
      </div>

      {answerTexts?.map((answerText) => {
          return answerText?.result_text?.length > 0 ? (
            <p 
              className="cke"
              dangerouslySetInnerHTML={{ __html: answerText.result_text }}
            >
            </p>
          ) : ''
        })}

        <div 
          class="mt-6 cke"
          dangerouslySetInnerHTML={{ __html: message }}
        >
        </div>

      <div className="answers">
        {showResults ?
          state[appId]?.data.questions.map((question) => {
            let topAnswer = 0;
            question.options.forEach(option => {
              topAnswer = option.score > topAnswer ? option.score : topAnswer
            });
            let userAnswer = state[appId]?.currentValues[answerIndex];
            answerIndex += 1;
            return (
              <div key={question.title}>
                <h4 dangerouslySetInnerHTML={{ __html: question.title }}></h4>
                <ul>
                  {question.options.map((option) => {
                    return (
                      <li key={option.score} className={option.score === topAnswer ? "top-answer" : ""}>
                        {userAnswer === option.score ? <sw-icon name="person" width="16"></sw-icon> : ""} {`${option.question_option}`}
                      </li>
                    )
                  })}
                </ul>
              </div>
              )
            })
        : null}
      </div>
    </>
  );
}

Result.defaultProps = {
  appId: 10,
};

Result.propTypes = {
  appId: PropTypes.string.isRequired,
};

export default Result;
